import axios from "axios";

export class SubscriptionService
{
	public GetFooter = (): Promise<any> =>
	{
		const url = `/website/footerwelcome2`;

		return axios.get(url)
			.catch((error) =>
			{
				console.log(error);
			});
	};
}